import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDrink = function SvgDrink(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M12.927 27.789h9.146M17.5 20.93v6.859M23.216 7.211l1.143 8.003c0 3.443-3.07 5.716-6.859 5.716s-6.86-2.273-6.86-5.716l1.144-8.003h11.432Z",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  }));
};
export default SvgDrink;